<template>
  <ValidationObserver>
    <div class="form-group">
      <label for="property.contact.email">Email</label>
      <ValidationProvider name="email" vid="property.contact.email" v-slot="{ errors }" rules="required">
        <input class="form-control" v-model="property.contact.email" :class="{ 'is-invalid': errors[0] }">
        <span class="text-danger">{{ errors[0] }}</span>
      </ValidationProvider>
    </div>

    <div class="form-group">
      <label for="property.contact.phone">Phone</label>
      <ValidationProvider name="phone" vid="property.contact.phone" v-slot="{ errors }" rules="required">
        <input class="form-control" v-model="property.contact.phone" :class="{ 'is-invalid': errors[0] }">
        <span class="text-danger">{{ errors[0] }}</span>
      </ValidationProvider>
    </div>
  </ValidationObserver>
</template>

<script>
const countryList = require('country-list');

export default {
  name: 'Contact',
  props: ['property']
}
</script>

<i18n>
{
  "en": {
    "email": "Email address",
    "phone": "Telefonska številka"
  },
  "sl": {
    "email": "Email naslov",
    "phone": "Telefonska številka"
  }
}
</i18n>
